<template>
  <div class="rt-editor" ref="rtEditor">

    <div v-if="!disabled" class="field has-addons rt-editor__toolbar">
      <p class="control">
        <button class="button is-small" type="button" title="Undo" @click="formatDoc('undo');">
          <span class="icon is-small">
            <i class="fas fa-undo"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Redo" @click="formatDoc('redo');">
          <span class="icon is-small">
            <i class="fas fa-redo"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Remove formatting" @click="formatDoc('removeFormat')">
          <span class="icon is-small">
            <i class="fas fa-remove-format"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Bold" @click="formatDoc('bold');">
          <span class="icon is-small">
            <i class="fas fa-bold"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Italic" @click="formatDoc('italic');">
          <span class="icon is-small">
            <i class="fas fa-italic"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Underline" @click="formatDoc('underline');">
          <span class="icon is-small">
            <i class="fas fa-underline"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Numbered list" @click="formatDoc('insertorderedlist');">
          <span class="icon is-small">
            <i class="fas fa-list-ol"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Dotted list" @click="formatDoc('insertunorderedlist');">
          <span class="icon is-small">
            <i class="fas fa-list-ul"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Delete indentation" @click="formatDoc('indent');">
          <span class="icon is-small">
            <i class="fas fa-indent"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-small" type="button" title="Delete indentation" @click="formatDoc('outdent');">
          <span class="icon is-small">
            <i class="fas fa-outdent"></i>
          </span>
        </button>
      </p>
      <p class="control">
        <button
          class="button is-small"
          type="button"
          title="Hyperlink"
          @click="createLink()">
          <span class="icon is-small">
            <i class="fas fa-link"></i>
          </span>
        </button>
      </p>
    </div>

    <div
      id="textBox"
      :contenteditable="!disabled"
      @input="updateValue()"
      @blur="blur()"
      class="textarea content"
      :disabled="disabled"
      :style="textBoxStyle">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    minHeight: {
      type: String,
      default: '80px'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorForm: null,
      oDoc: null, // text box
      oContent: null
    }
  },
  computed: {
    textBoxStyle() {
      return {
        'min-height': this.minHeight
      }
    }
  },
  watch: {
    value(v) {
      if (!v || v == '') {
        this.oDoc.innerHTML = v;
      } else if (!this.oDoc.innerHTML) {
        this.oDoc.innerHTML = v;
      }
    }
  },
  mounted() {
    this.initDoc();
  },
  methods: {
    initDoc() {
      this.editorForm = this.$refs.rtEditor.$el;
      this.oDoc = this.$refs.rtEditor.querySelector("#textBox");
      if (this.value) {
        this.oDoc.innerHTML = this.value;
      }
      this.$emit('input', this.oDoc.innerHTML);
    },
    formatDoc(sCmd, sValue) {
      document.execCommand(sCmd, false, sValue); this.oDoc.focus();
      this.$emit('input', this.oDoc.innerHTML);
    },
    createLink() {
      var sLnk=prompt('Write the URL here','http://');
      if(sLnk && sLnk!='' && sLnk!='http://' && sLnk != 'https://') {
        if (!sLnk.includes('http://') && !sLnk.includes('https://')) {
          sLnk = `https://${sLnk}`
        }
        this.formatDoc('createlink', sLnk);
      }
    },
    updateValue() {
      this.$emit('input', this.oDoc.innerHTML);
    },
    blur() {
      this.$emit('blur', this.oDoc.innerHTML);
    }
  }
}
</script>

<style lang="scss" scoped>
.rt-editor .rt-editor__toolbar {
  margin-bottom: 0em !important;
  width: 100%;
  background: whitesmoke;
  border-radius: 4px;
}

.rt-editor .rt-editor__toolbar button {
  background: whitesmoke
}

.rt-editor #textBox {
  width: 100%;
  padding: 0.5em 0.8em;
  overflow: auto;
}

.rt-editor .control {
  margin-bottom: 0px;
}

.content ul, .content ol {
  margin-block-start: 0.2em !important;
}

.rt-editor .placeholder {
  background: #efefef;
}
</style>
